import {
    FETCH_DEALS_FAILURE,
    FETCH_DEALS_REQUEST,
    FETCH_DEALS_SUCCESS,
    SELECT_VEHICLE,
    SHOW_CUSTOMER_VEHICLES_SLIDEOUT,
    HIDE_CUSTOMER_VEHICLES_SLIDEOUT,
    SET_DEAL_LIST_COMPARE_ENABLED,
    CHECK_OUT_USER,
    FETCH_TRADE_INS_REQUEST,
    FETCH_TRADE_INS_SUCCESS,
    FETCH_TRADE_INS_FAILURE,
    SELECTED_DEAL,
    CONTINUE_TO_APPLY_DEAL,
    PAYMENT_FAILURE,
    SP_DXG_SAVE_REQUEST_FAILURE,
    SHOW_TRADE_IN_MODAL,
    HIDE_TRADE_IN_MODAL
} from './actions';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import { groupedDealsToArray, updateDealsWithTradeIns } from '../utils/utils';
import type { CustomerVehiclesState } from '../types';
import { initialState } from './initialState';

export const customerVehiclesReducer = (state = initialState, action: any): CustomerVehiclesState => {
    switch (action.type) {
        case CHECK_OUT_USER:
            // Reset customer vehicles state on checkout to prevent stale deals from showing
            return initialState;
        case FETCH_DEALS_REQUEST:
            return {
                ...state,
                requestStatus: ApiRequestStatus.Loading,
                error: null
            };
        case FETCH_DEALS_SUCCESS: {
            const deals = groupedDealsToArray(action.payload.deals);
            return {
                ...state,
                deals,
                // Total deals across all vehicle groups — kept in sync with `deals`, its source.
                // groupedDealsToArray guarantees each group carries a non-empty `deals` array.
                dealsCount: deals.reduce((total, group) => total + group.deals.length, 0),
                requestStatus: ApiRequestStatus.Success,
                error: null
            };
        }
        case FETCH_DEALS_FAILURE:
            return {
                ...state,
                requestStatus: ApiRequestStatus.Error,
                error: action.payload
            };
        case SELECT_VEHICLE:
            return {
                ...state,
                selectedVehicle: action.payload
            };
        case SHOW_CUSTOMER_VEHICLES_SLIDEOUT:
            return {
                ...state,
                isOpen: true,
                customerFirstName: action.payload?.customerFirstName
            };
        case HIDE_CUSTOMER_VEHICLES_SLIDEOUT:
            return {
                ...state,
                isOpen: false
            };
        case SET_DEAL_LIST_COMPARE_ENABLED:
            return {
                ...state,
                isDealListCompareEnabled: action.payload
            };

        case FETCH_TRADE_INS_REQUEST: {
            return {
                ...state,
                updateTradeInsStatus: ApiRequestStatus.Loading
            };
        }
        case FETCH_TRADE_INS_SUCCESS: {
            const rawData: Array<{ dealXgId: string; version: string; trades?: any[] }> = action.payload?.data ?? [];
            const trades = rawData.map((item) => ({
                dealXgId: item.dealXgId,
                version: item.version,
                tradeIns: item.trades ?? []
            }));
            const updatedDeals = updateDealsWithTradeIns(state.deals, trades);
            return {
                ...state,
                deals: updatedDeals,
                updateTradeInsStatus: ApiRequestStatus.Success
            };
        }
        case FETCH_TRADE_INS_FAILURE: {
            return {
                ...state,
                updateTradeInsStatus: ApiRequestStatus.Error
            };
        }
        case SELECTED_DEAL: {
            return {
                ...state,
                selectedDealId: action.payload.dealId,
                selectedDealVersion: action.payload.version
            };
        }
        case SHOW_TRADE_IN_MODAL: {
            return {
                ...state,
                isTradeInModalVisible: true
            };
        }
        case HIDE_TRADE_IN_MODAL: {
            return {
                ...state,
                isTradeInModalVisible: false
            };
        }
        case CONTINUE_TO_APPLY_DEAL: {
            return {
                ...state,
                isTradeInsUpdated: true,
                updateTradeInsStatus: ApiRequestStatus.Loading
            };
        }

        case PAYMENT_FAILURE:
        case SP_DXG_SAVE_REQUEST_FAILURE: {
            return {
                ...state,
                updateTradeInsStatus: ApiRequestStatus.Error
            };
        }
        default:
            return state;
    }
};
